import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { getAssetUrl } from '../../../utils';
import { Toolbar } from './Toolbar';
import { Body } from './Body';

const Root = styled.div`
  background-color: ${globalTheme.palette.primary};
  background-image: url(${getAssetUrl('header-bg.png')});
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
`;

export const Header: FC = () => (
  <Root>
    <Toolbar />
    <Body />
  </Root>
);
